<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-heading">
      <div class="row">
        <div class="col-xs-20">
          <h5>
            Month-By-Month Development
          </h5>
        </div>

        <div class="col-xs-4">
          <SelectWidget
              v-if="!loading"
              v-model="granularity"
              class="form-control input-sm"
              :options="[{value: 'months', label: 'Months'}, {value: 'quarters', label: 'Quarters'}, {value: 'years', label: 'Years'}]"
          />
        </div>
      </div>
    </div>

    <LoadingSpinner v-if="loading" :style="loadingSpinnerStyle"/>

    <div v-else class="panel-body">
      <div v-if="rows.length">
        <MonthlyChart
            :year="year"
            :user="user"
            :publication-based-channel="publicationBasedChannel"
            :granularity="granularity"
            :target-metric="targetMetric"
            :rows="rows"
            :portal="portal"
            :loading="loading"
        />

        <hr>

        <MonthlyTable
            :year="year"
            :granularity="granularity"
            :target-metric="targetMetric"
            :rows="rows"
        />
      </div>

      <div v-else class="text-center text-muted" style="margin: 22px 0">
        There is no data to display!
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import SaveHeight from '@/mixins/SaveHeight'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import MonthlyChart from './MonthlyChart'
import MonthlyTable from './MonthlyTable'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'

export default {
  components: {LoadingSpinner, MonthlyChart, MonthlyTable, SelectWidget},

  mixins: [SaveHeight],

  props: ['year', 'portal', 'publicationBasedChannel', 'targetMetric', 'user'],

  data() {
    return {
      granularity: 'months',
      loading: true,
      rows: null
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    year() {
      this.load()
    },

    targetMetric() {
      this.load()
    },

    publicationBasedChannel() {
      this.load()
    },

    user() {
      this.load()
    },

    granularity() {
      this.load()
    }
  },

  computed: {
    granularityDimension() {
      if (this.granularity === 'months') {
        return 'publish_month'
      }

      if (this.granularity === 'quarters') {
        return 'publish_quarter'
      }

      return 'publish_year'
    },

    filters() {
      return [
        {dimension: 'publish_year', operator: '=', value: this.year},
        {dimension: 'publication_based_channel_id', operator: '=', value: this.publicationBasedChannel.id}
      ]
    },

    filtersWithUser() {
      if (!this.user) {
        return this.filters
      }

      return this.filters.concat({dimension: 'user_id', operator: '=', value: this.user})
    }
  },

  methods: {
    load() {
      this.saveHeight()

      this.loading = true

      Promise.all([
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: 'publication_ad_value_after_costs'},
          ],
          dimensions: [
            {name: this.granularityDimension},
          ],
          filters: this.filtersWithUser
        }),
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: this.targetMetric},
          ],
          dimensions: [
            {name: this.granularityDimension},
          ],
          filters: this.filters
        })
      ]).then(responses => {
        this.rows = responses[0].data.data.concat(responses[1].data.data)

        this.loading = false
      })
    },
  }
}
</script>
